var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnCampus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5964",
    "data-name": "Group 5964",
    transform: "translate(10413 -5798)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_98",
    "data-name": "Ellipse 98",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(-10413 5798)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "location-pin_1_",
    "data-name": "location-pin(1)",
    d: "M10.468,0A7.5,7.5,0,0,0,3,7.522C3,13.415,9.766,19.5,10.054,19.756a.624.624,0,0,0,.828,0c.288-.256,7.054-6.342,7.054-12.235A7.5,7.5,0,0,0,10.468,0Zm0,11.616a4.149,4.149,0,1,1,4.149-4.149A4.153,4.153,0,0,1,10.468,11.616Z",
    transform: "translate(-10408 5803)",
    fill: "#3f2566"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnCampus);
export default __webpack_public_path__ + "static/media/on_campus.366c2405697397a71541760d7a115775.svg";
export { ForwardRef as ReactComponent };